'use client';

import { c as _c } from "react/compiler-runtime";
import { features } from '@/src/constants/featurespage';
import { Footertopnew } from '../Footertopnew';
import type { IFeature2 } from '../home.interface';
import { DataTypeFeature } from './DataTypeFeature';
import { Feature2 } from './Feature2';
export interface IProps {
  feature: IFeature2;
  index: number;
}

/* Main Component */
export const FeaturesPage = () => {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h1 className="container mx-auto px-2 text-left text-[34px] font-medium text-[#3D3E40] md:px-4 md:py-0 md:text-center md:text-3xl xl:text-[44px]">Why you’ll love AbleSpace</h1>;
    t1 = <p className="container mx-auto pl-2 pr-6 text-[15px] font-normal text-[#3D3E40] md:m-auto md:mt-2 md:w-[90%] md:px-4 md:py-0 md:text-center md:text-[24px] lg:w-[80%] lg:px-40">AbleSpace ensures you spend less time on paperwork and more time with students. Our suite of features helps you automate routine tasks.</p>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <section className=" mt-24 p-4 lg:mt-40">{t0}{t1}<div className="mt-10 flex flex-col gap-y-4">{features.map(_temp)}</div><Footertopnew /></section>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
function _temp(feature, index) {
  if (feature.type) {
    return <DataTypeFeature key={index} index={index} feature={{
      ...feature,
      imageUrl: `/images/icons/feature-screen/features-${index + 1}.png`
    }} />;
  }
  return <Feature2 key={index} index={index + 1} feature={{
    ...feature,
    imageUrl: `/images/icons/feature-screen/feature-${index + 1}`
  }} />;
}